import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('.event-gallery');
  
  if (gallery) {
    // uses data-splide attribute to get slider settings
    var splide4 = new Splide('.event-gallery');
    
    // Fix pagination(remove clone/duplicates)
    splide4.on('mounted', function() {
      // Wait a brief moment to ensure pagination is fully rendered
      setTimeout(() => {
        const paginationList = document.querySelector('.splide__pagination');
        
        if (paginationList) {
          const paginationButtons = paginationList.querySelectorAll('button');
          const seenSlides = new Set();
          
          // Loop through buttons and remove duplicates
          Array.from(paginationButtons).forEach(button => {
            // Get the slide ID this button controls
            const slideId = button.getAttribute('aria-controls');
            
            // If we've seen this slide before, remove this button's parent (the <li>)
            if (seenSlides.has(slideId)) {
              button.parentElement.remove();
            } else {
              // Otherwise, add to our set of seen slides
              seenSlides.add(slideId);
            }
          });
        }
      }, 10); // Short timeout to ensure DOM is ready
    });
    
    // Mount the slider
    splide4.mount();
  }
});